import React from 'react';
import { useParams } from 'react-router-dom';
import { constellationData } from '../data/constellationData';
import ConstellationIcon from '../components/icons/ConstellationIcon';
import './ConstellationDetailPage.css';

const ConstellationDetailPage = () => {
  let { name } = useParams();
  const data = constellationData[name];

  if (!data) {
    return <div>星座未找到</div>;
  }

  return (
    <>
      <title>{`${data.chineseName} (${name}) - 星座探秘`}</title>
      <meta name="description" content={`深入了解${data.chineseName}的性格特点、神话故事、优缺点以及最佳配对。`} />
      <div className="detail-page">
        <div className="detail-header">
          <ConstellationIcon name={name} width="120" height="120" />
          <div className="header-text">
            <h1>{data.chineseName}</h1>
            <h2>{data.name} ({data.date})</h2>
          </div>
        </div>
        <div className="detail-section">
          <h3>性格特点</h3>
          <p>{data.details.personality}</p>
        </div>
        <div className="detail-section">
          <h3>优点与缺点</h3>
          <div className="strengths-weaknesses">
            <div className="strengths">
              <h4>优点</h4>
              <ul>
                {data.details.strengths.map(s => <li key={s}>{s}</li>)}
              </ul>
            </div>
            <div className="weaknesses">
              <h4>缺点</h4>
              <ul>
                {data.details.weaknesses.map(w => <li key={w}>{w}</li>)}
              </ul>
            </div>
          </div>
        </div>
        <div className="detail-section">
          <h3>职业建议</h3>
          <p>{data.details.career}</p>
        </div>
        <div className="detail-section">
          <h3>神话故事</h3>
          <p>{data.details.myth}</p>
        </div>
        <div className="detail-section">
          <h3>最佳配对</h3>
          <p>{data.details.compatibility}</p>
        </div>
      </div>
    </>
  );
};

export default ConstellationDetailPage;
